import React from "react";
import Playstore from "../../assets/img/app-store.png";
import Google from "../../assets/img/google-play.png";
import Button from "../common-components/buttons/Button";

const WebFooter = () => {
  return (
    <>
      <footer className="bg-white sm:pb-[48px] pb-[20px] sm:pt-[64px] pt-40">
        <div className="container mx-auto 2xl:max-w-screen-xl sm:px-5 px-2">
          <div className="flex tab:flex-nowrap flex-wrap tab:gap-6 gap-4">
            {/* Left Section - Logo and App Links */}
            <div className="tab:w-52 w-full flex-auto">
              <svg
                width="128"
                height="32"
                viewBox="0 0 128 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.816406"
                  width="32"
                  height="32"
                  rx="8"
                  fill="#474DF4"
                ></rect>
                <path
                  d="M28.0949 12.2633V22.9648L21.9834 21.6303V11.7334C21.9834 11.0619 21.6831 10.4443 21.1561 10.0306C20.6262 9.6226 19.9576 9.48093 19.3087 9.64243L9.74902 12.0451V7.99908L19.4844 5.5454C21.5641 5.02123 23.7344 5.48023 25.4316 6.80341C27.1259 8.12375 28.0949 10.1128 28.0949 12.2661V12.2633Z"
                  fill="white"
                ></path>
                <path
                  d="M21.9835 21.6302V26.8095L10.5537 24.3162C7.5844 23.6673 5.42822 20.9898 5.42822 17.9553V13.1358L9.74907 12.0449V16.7568C9.74907 18.0346 10.6586 19.1595 11.9081 19.4315L21.9835 21.6273V21.6302Z"
                  fill="white"
                ></path>
                <g clipPath="url(#clip0_1334_298)">
                  <path
                    d="M50.9964 16.8375C49.0939 16.585 47.4789 16.37 47.4789 15.0075C47.4789 13.9675 48.4114 13.0675 50.2789 13.0675C51.9664 13.0675 52.9689 13.8225 53.0789 14.9H57.3164C57.2089 11.7775 54.5514 9.33496 50.2089 9.33496C45.8664 9.33496 43.1739 11.705 43.1739 15.3325C43.1739 19.675 47.1964 20.14 49.9239 20.5C51.8239 20.7525 53.4039 20.93 53.4039 22.295C53.4039 23.37 52.4714 24.2675 50.2814 24.2675C48.0914 24.2675 47.1589 23.475 47.1214 22.295H42.8164C42.9239 25.595 45.7589 28 50.2789 28C54.7989 28 57.7089 25.6325 57.7089 22.0425C57.7089 17.6275 53.3664 17.1625 50.9964 16.84V16.8375Z"
                    fill="#1F242E"
                  ></path>
                  <path
                    d="M68.5813 9.3374C63.3438 9.3374 59.7563 12.1974 59.7563 18.1174V27.9999H63.9913V18.1174C63.9913 14.7424 65.8888 13.3224 68.5813 13.3224C71.2738 13.3224 73.1688 14.7424 73.1688 18.1174V27.9999H77.4038V18.1174C77.4038 12.1599 73.8213 9.3374 68.5813 9.3374Z"
                    fill="#1F242E"
                  ></path>
                  <path
                    d="M90.419 9.3375C87.874 9.3375 85.754 10.415 84.499 12.39L84.464 4H80.229V18.525C80.229 24.2675 84.1065 28 89.6665 28C95.2265 28 99.249 24.1225 99.249 18.49C99.249 12.425 94.729 9.34 90.4215 9.34H90.419V9.3375ZM89.7015 24.015C86.579 24.015 84.499 21.79 84.499 18.6675C84.499 15.545 86.5815 13.3225 89.7015 13.3225C92.8215 13.3225 94.9415 15.545 94.9415 18.6675C94.9415 21.79 92.824 24.015 89.7015 24.015Z"
                    fill="#1F242E"
                  ></path>
                  <path
                    d="M102.111 4L102.076 28H106.346V4H102.111Z"
                    fill="#1F242E"
                  ></path>
                  <path
                    d="M118.376 9.3374C112.741 9.3374 108.794 13.2149 108.794 18.8499C108.794 24.9149 113.316 27.9999 117.621 27.9999C120.424 27.9999 122.829 26.6724 123.904 24.0524V27.9999H127.816V18.8124C127.816 13.1074 123.939 9.3374 118.376 9.3374ZM118.341 24.0149C115.216 24.0149 113.101 21.7899 113.101 18.6674C113.101 15.5449 115.216 13.3224 118.341 13.3224C121.466 13.3224 123.544 15.5449 123.544 18.6674C123.544 21.7899 121.459 24.0149 118.341 24.0149Z"
                    fill="#1F242E"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_1334_298">
                    <rect
                      width="85"
                      height="24"
                      fill="white"
                      transform="translate(42.8164 4)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
              <div className="flex space-x-2 mt-5">
                <a href="#" className="">
                  <img
                    src={Playstore}
                    alt="Download on the App Store"
                    className="mr-2 inline h-[40px] w-[135px]"
                  />
                </a>
                <a href="#" className="">
                  <img
                    src={Google}
                    alt="Get it on Google Play"
                    className="mr-2 inline h-[40px] w-[135px]"
                  />
                </a>
              </div>
            </div>

            {/* Explore Section */}
            <div className="tab:w-16 w-full  flex-auto">
              <h3 className="md:mb-4 mb-3 font-normal text-[#686E7D]">
                EXPLORE
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-3">
                  <a href="#" className="font-medium sm:text-base text-sm">
                    Careers
                  </a>
                  <Button
                    type="secondary"
                    className="h-[24px] !rounded-[4px] px-[8px] py-0 text-[12px] font-medium"
                    onClick={() => alert("Primary Button Clicked")}
                  >
                    We&apos;re hiring
                  </Button>
                </li>
                <li>
                  <a
                    href="#"
                    className="flex items-center gap-2 font-medium  sm:text-base text-sm"
                  >
                    Newsroom
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M12.6667 12.6715H3.33333V3.33822H8V2.00488H3.33333C2.59333 2.00488 2 2.60488 2 3.33822V12.6715C2 13.4049 2.59333 14.0049 3.33333 14.0049H12.6667C13.4 14.0049 14 13.4049 14 12.6715V8.00488H12.6667V12.6715ZM9.33333 2.00488V3.33822H11.7267L5.17333 9.89155L6.11333 10.8315L12.6667 4.27822V6.67155H14V2.00488H9.33333Z"
                        fill="#1F242E"
                      />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>

            {/* Learn Section */}
            <div className="tab:w-16 w-full  flex-auto">
              <h3 className="md:mb-4 mb-3 font-normal text-[#686E7D]">LEARN</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="font-medium sm:text-base text-sm">
                    Savers Community
                  </a>
                </li>
                <li>
                  <a href="#" className="font-medium sm:text-base text-sm">
                    Newsletter
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal Section */}
            <div className="tab:w-16  w-full  flex-auto">
              <h3 className="md:mb-4 mb-3 font-normal text-[#686E7D]">LEGAL</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="font-medium sm:text-base text-sm">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a href="#" className="font-medium sm:text-base text-sm">
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="tab:mt-[80px] mt-4 gap-3 flex flex-col-reverse items-center justify-between border-t border-[#E9EBF0] tab:pt-[32px] pt-0 md:flex-row">
            <p className="text-[12px] text-[#686E7D]">
              Copyright© 2024 Helios Innovation IT Co., All rights reserved.
            </p>
            <div className="mt-4 flex space-x-6 md:mt-0">
              <a href="#" className="">
                {/* <i className="fab fa-linkedin"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1334_4622)">
                    <path
                      d="M22.2234 0.00488281H1.77187C0.792187 0.00488281 0 0.77832 0 1.73457V22.2705C0 23.2268 0.792187 24.0049 1.77187 24.0049H22.2234C23.2031 24.0049 24 23.2268 24 22.2752V1.73457C24 0.77832 23.2031 0.00488281 22.2234 0.00488281ZM7.12031 20.4564H3.55781V9.00019H7.12031V20.4564ZM5.33906 7.43926C4.19531 7.43926 3.27188 6.51582 3.27188 5.37676C3.27188 4.2377 4.19531 3.31426 5.33906 3.31426C6.47813 3.31426 7.40156 4.2377 7.40156 5.37676C7.40156 6.51113 6.47813 7.43926 5.33906 7.43926ZM20.4516 20.4564H16.8937V14.8877C16.8937 13.5611 16.8703 11.8502 15.0422 11.8502C13.1906 11.8502 12.9094 13.2986 12.9094 14.7939V20.4564H9.35625V9.00019H12.7687V10.5658H12.8156C13.2891 9.66582 14.4516 8.71426 16.1813 8.71426C19.7859 8.71426 20.4516 11.0861 20.4516 14.1705V20.4564Z"
                      fill="#4E5663"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1334_4622">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.00488281)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a href="#">
                {/* <i className="fab fa-instagram"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1334_4624)">
                    <path
                      d="M12 2.16582C15.2063 2.16582 15.5859 2.17988 16.8469 2.23613C18.0188 2.2877 18.6516 2.48457 19.0734 2.64863C19.6313 2.86426 20.0344 3.12676 20.4516 3.54395C20.8734 3.96582 21.1313 4.36426 21.3469 4.92207C21.5109 5.34395 21.7078 5.98145 21.7594 7.14863C21.8156 8.41426 21.8297 8.79395 21.8297 11.9955C21.8297 15.2018 21.8156 15.5814 21.7594 16.8424C21.7078 18.0143 21.5109 18.6471 21.3469 19.0689C21.1313 19.6268 20.8687 20.0299 20.4516 20.4471C20.0297 20.8689 19.6313 21.1268 19.0734 21.3424C18.6516 21.5064 18.0141 21.7033 16.8469 21.7549C15.5813 21.8111 15.2016 21.8252 12 21.8252C8.79375 21.8252 8.41406 21.8111 7.15313 21.7549C5.98125 21.7033 5.34844 21.5064 4.92656 21.3424C4.36875 21.1268 3.96563 20.8643 3.54844 20.4471C3.12656 20.0252 2.86875 19.6268 2.65313 19.0689C2.48906 18.6471 2.29219 18.0096 2.24063 16.8424C2.18438 15.5768 2.17031 15.1971 2.17031 11.9955C2.17031 8.78926 2.18438 8.40957 2.24063 7.14863C2.29219 5.97676 2.48906 5.34395 2.65313 4.92207C2.86875 4.36426 3.13125 3.96113 3.54844 3.54395C3.97031 3.12207 4.36875 2.86426 4.92656 2.64863C5.34844 2.48457 5.98594 2.2877 7.15313 2.23613C8.41406 2.17988 8.79375 2.16582 12 2.16582ZM12 0.00488281C8.74219 0.00488281 8.33438 0.0189453 7.05469 0.0751953C5.77969 0.131445 4.90313 0.337695 4.14375 0.633008C3.35156 0.942383 2.68125 1.3502 2.01563 2.02051C1.34531 2.68613 0.9375 3.35645 0.628125 4.14395C0.332812 4.90801 0.126563 5.77988 0.0703125 7.05488C0.0140625 8.33926 0 8.74707 0 12.0049C0 15.2627 0.0140625 15.6705 0.0703125 16.9502C0.126563 18.2252 0.332812 19.1018 0.628125 19.8611C0.9375 20.6533 1.34531 21.3236 2.01563 21.9893C2.68125 22.6549 3.35156 23.0674 4.13906 23.3721C4.90313 23.6674 5.775 23.8736 7.05 23.9299C8.32969 23.9861 8.7375 24.0002 11.9953 24.0002C15.2531 24.0002 15.6609 23.9861 16.9406 23.9299C18.2156 23.8736 19.0922 23.6674 19.8516 23.3721C20.6391 23.0674 21.3094 22.6549 21.975 21.9893C22.6406 21.3236 23.0531 20.6533 23.3578 19.8658C23.6531 19.1018 23.8594 18.2299 23.9156 16.9549C23.9719 15.6752 23.9859 15.2674 23.9859 12.0096C23.9859 8.75176 23.9719 8.34395 23.9156 7.06426C23.8594 5.78926 23.6531 4.9127 23.3578 4.15332C23.0625 3.35645 22.6547 2.68613 21.9844 2.02051C21.3188 1.35488 20.6484 0.942383 19.8609 0.637695C19.0969 0.342383 18.225 0.136133 16.95 0.0798828C15.6656 0.0189453 15.2578 0.00488281 12 0.00488281Z"
                      fill="#4E5663"
                    />
                    <path
                      d="M12 5.84082C8.59688 5.84082 5.83594 8.60176 5.83594 12.0049C5.83594 15.408 8.59688 18.1689 12 18.1689C15.4031 18.1689 18.1641 15.408 18.1641 12.0049C18.1641 8.60176 15.4031 5.84082 12 5.84082ZM12 16.0033C9.79219 16.0033 8.00156 14.2127 8.00156 12.0049C8.00156 9.79707 9.79219 8.00645 12 8.00645C14.2078 8.00645 15.9984 9.79707 15.9984 12.0049C15.9984 14.2127 14.2078 16.0033 12 16.0033Z"
                      fill="#4E5663"
                    />
                    <path
                      d="M19.8469 5.59702C19.8469 6.3939 19.2 7.03609 18.4078 7.03609C17.6109 7.03609 16.9688 6.38921 16.9688 5.59702C16.9688 4.80015 17.6156 4.15796 18.4078 4.15796C19.2 4.15796 19.8469 4.80483 19.8469 5.59702Z"
                      fill="#4E5663"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1334_4624">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.00488281)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a href="#">
                {/* <i className="fab fa-twitter"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18.3263 1.90881H21.6998L14.3297 10.3323L23 21.7948H16.2112L10.894 14.8429L4.80995 21.7948H1.43443L9.31743 12.7849L1 1.90881H7.96111L12.7674 8.26315L18.3263 1.90881ZM17.1423 19.7756H19.0116L6.94539 3.82195H4.93946L17.1423 19.7756Z"
                    fill="#4E5663"
                  />
                </svg>
              </a>
              <a href="#">
                {/* <i className="fab fa-tiktok"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1334_4630)">
                    <path
                      d="M17.0725 0.00488281H13.0278V16.3527C13.0278 18.3006 11.4722 19.9006 9.53626 19.9006C7.60034 19.9006 6.04469 18.3006 6.04469 16.3527C6.04469 14.4397 7.56577 12.8744 9.43257 12.8049V8.70055C5.31872 8.77008 2 12.144 2 16.3527C2 20.5962 5.38786 24.0049 9.57085 24.0049C13.7538 24.0049 17.1416 20.5614 17.1416 16.3527V7.97008C18.6627 9.08315 20.5295 9.74402 22.5 9.77882V5.67445C19.4579 5.5701 17.0725 3.06575 17.0725 0.00488281Z"
                      fill="#4E5663"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1334_4630">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.00488281)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default WebFooter;
